import styled from 'styled-components';

const CheckboxColumn = styled.div`
  width: 16px;
  height: 16px;
  position: absolute;
  right: 0;
`;

export default CheckboxColumn;
